export class DTOAcompanharPix{ 
    NumSolicitacao : string;
    PrimeiraCartela : string;
    SegundaCartela : string;
    CnpjEmpresaVendedor: string;
    NomeEmpresaVendedor: string;
    CodRepresentante: number;
    NomeRepresentante: string;        
    Status: string;
    ImgFrente: string;
    ImgVerso: string;
    Obs: string;
    ObsLog: string;
    VeInfoPix: boolean=false;
    ChavePix: string;
    VlrPix: string;
    TipoChavePix: string;
    NomeBanco: string;
    Cidade: string;
    Contato: string;

    deserialize(input: Object): DTOAcompanharPix {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoAcompanharPix.ts